// Route paths constants
export const ROUTES = {
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot-password",
  FORGOT_PASSWORD_SENT: "/forgot-password-sent",
  NEW_PASSWORD: "/new-password",
  E_LEARNING: "/e-learning",
  COMPANY: "/company",
  CONSULTATION: "/consulation",
  INSPECTION: "/monthly-inspections",
  STORE_INSPECTION_RESULTS: "/store-inspection-results",
  MONTHLY_CHECK: "/monthly-check",
  NOTIFICATION_MANAGEMENT: "/notification",
  ERROR_404: "/404",
  ERROR_500: "/500",
  ERROR_403: "/403",
  STORE: "/store",
  USER: "/user-information",
  ME: "/me",
  CHAT: "/chat-management",
} as const;

// E-Learning sub-routes
export const E_LEARNING_SUB_ROUTES = {
  UNITS: "e-learning/units/:id",
  QUIZ_RESULT: "e-learning/quizzes/:id/result",
  QUIZ_CATEGORY: "e-learning/quiz-category/:id",
  DONE_QUIZ_CATEGORY: "e-learning/done-quiz-category/:id",
} as const;

// Store sub-routes
export const STORE_SUB_ROUTES = {
  DETAIL: "store/:id",
} as const;

// User sub-routes
export const USER_SUB_ROUTES = {
  DETAIL: "user-information/:id",
  LEARNING: "user-information/:id/learning",
};

export const CHAT_SUB_ROUTES = {
  CHAT_ROOM: ":id",
};

// Monthly inspection sub-routes
export const MONTHLY_INSPECTION_SUB_ROUTES = {
  DETAIL: "monthly-inspections/:id",
};

export const STORE_INSPECTION_RESULTS_SUB_ROUTES = {
  DETAIL: "store-inspection-results/:id",
};
